// Language options for the select dropdown
const LANGUAGE_OPTIONS = [
    { key: 'fr', value: 'fr-FR', name: 'Français - FR' },
    { key: 'en', value: 'en-US', name: 'English - US' },
    { key: 'es', value: 'es-ES', name: 'Español - ES' }
];
export default LANGUAGE_OPTIONS;